import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['businessOrPersonalSelect', 'bankListContainer', 'personalAccountFlashWarning', 'importTransactionsFrom'];

  connect() {
    this.updateBusinessOrPersonal();
  }

  beginAuth(event) {
    event.preventDefault();
    event.stopPropagation();
    const originalLink = event.target.closest('a');
    const newUrl = originalLink.href + '&import_transactions_from=' + this.importTransactionsFromTarget.value;
    window.location.href = newUrl;
  }

  updateBusinessOrPersonal() {
    var chosen_value = this.businessOrPersonalSelectTarget.value;
    if(chosen_value == 'personal') {
      this.personalAccountFlashWarningTarget.classList.remove('hidden')
    } else {
      this.personalAccountFlashWarningTarget.classList.add('hidden')
    }

    Array.from(this.bankListContainerTarget.children).forEach((elem) => {
      elem.classList.add('hidden');
      if(elem.dataset.businessOrPersonal == chosen_value) { elem.classList.remove('hidden') }
    });
  }
}